import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { emaki_brand } from "./types/emaki_brand";
import { IMAGE_CROP_POSITION_ENABLED_BRAND_IDS, IMAGE_OPTIMIZATION_DISABLED_BRAND_IDS } from "./consts/brand";

/**
 * Get the brand info data from the vnAppZone object.
 * By default, this retrieves the currently viewed brand from the url.
 * Optionally supply a specific idBrand value to pull that data from the set, if it exists.
 *
 * @param vnAppZoneObj vnAppZone object
 * @param idBrand Optional idBrand parameter for checking if a brand is in the user's data
 * @returns emaki_brand|null
 */
export const getBrandInfoFromVnAppZone = (vnAppZoneObj: vnAppZone, idBrand: number|null = null): emaki_brand|null => {
    const vnApp = vnAppZoneObj.getApp();
    if (!idBrand) {
        idBrand = vnApp.params.idBrand? vnApp.params.idBrand : null;
    }
    const userBrands = vnApp.loggedUser.user.brands;

    const filteredBrands = userBrands.filter((brand) => brand.id == idBrand);

    return filteredBrands[0]? filteredBrands[0] : null;
};

/**
 *  Get all the brand info data from the vnAppZone object.
 * 
 * @param vnAppZoneObj vnAppZone object
 * @returns emaki_brand
 */
export const getAllBrandsFromVnAppZone = (vnAppZoneObj: vnAppZone): emaki_brand => {
    return vnAppZoneObj.getApp().loggedUser.user.brands;
};

/**
 * Check whether image optimization is enabled for a brand.
 *
 * @param idBrand Brand ID to check
 * @returns Whether image optimization is enabled
 */
export const isImageOptimizationEnabled = (idBrand: number): boolean => {
    return IMAGE_OPTIMIZATION_DISABLED_BRAND_IDS.indexOf(idBrand) === -1;
};

/**
 * Check whether image crop positions can be set for a brand.
 *
 * @param idBrand Brand ID to check
 * @returns Whether image crop positions are enabled
 */
export const isImageCropPositionEnabled = (idBrand: number): boolean => {
    return IMAGE_CROP_POSITION_ENABLED_BRAND_IDS.indexOf(Number(idBrand)) !== -1;
};



// WEBPACK FOOTER //
// ./js/utils/BrandHelper.ts